import * as React from 'react';

import { log } from 'helper/debug';

type ErrorBoundaryProps = {
	children: any;
};

type ErrorBoundaryState = {
	hasError: boolean;
	error?: Error;
	info?: any;
};

let privateErrorTimeoutCounter = 0;

const ERROR_BOUNDARY_RENDER_LOOP_TIMEOUT = 20;

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
	public static displayName = 'ErrorBoundary';

	public state: ErrorBoundaryState = {
		hasError: false,
	};

	public shouldComponentUpdate(nextProps: Readonly<ErrorBoundaryProps>, nextState: Readonly<ErrorBoundaryState>) {
		if (nextState.hasError) {
			privateErrorTimeoutCounter++;
		}

		if (privateErrorTimeoutCounter > ERROR_BOUNDARY_RENDER_LOOP_TIMEOUT) {
			// prevent re-render endless cycles
			return false;
		}

		return true;
	}

	public componentDidCatch(error: Error, info: any) {
		this.setState({
			hasError: true,
			error,
			info,
		});
	}

	public render() {
		const { hasError, error, info } = this.state;

		if (hasError) {
			log(`ErrorBoundary caught error: ${error ? error.toString() : 'Unknown error'}. ${info || ''}`);
		}

		return this.props.children;
	}
}
